import React from 'react'

import { DatasetCategory } from 'src/commons/chartjs'
import ComparisonPlot from 'src/commons/graphs/ComparisonPlot'
import { IGraphCompareWithTotal, IGraphCompare } from 'src/commons/types'
import { formatWeight } from 'src/commons/utils'
import { useAgencySettings } from 'src/layout/AgencySettings'

export function EnergyConsumptionPerProvider(props: IGraphCompare) {
  const { distance_unit } = useAgencySettings()

  return (
    <ComparisonPlot
      title={props.title}
      rawData={props.graphReport ?? []}
      granularity={props.granularity}
      datasetCategory={DatasetCategory.provider}
      enableAnimation={props.enableAnimation}
      formatWithUnit={(x) => `${x} kWh/${distance_unit}`}
    />
  )
}

export function EmissionsPerProvider(props: IGraphCompareWithTotal) {
  const { distance_unit } = useAgencySettings()

  if (!props.graphReport) {
    return null
  }

  let isMetric = true
  if (distance_unit === 'miles') {
    isMetric = false
  }
  return (
    <ComparisonPlot
      title={props.title}
      rawData={props.graphReport.data ? props.graphReport.data : ([] as any)}
      granularity={props.granularity}
      datasetCategory={DatasetCategory.provider}
      enableAnimation={props.enableAnimation}
      formatWithUnit={(x) => formatWeight(x, isMetric)}
    />
  )
}
export function EmissionsCompareToAlternateMode(props: IGraphCompare) {
  const { distance_unit } = useAgencySettings()
  let isMetric = true
  if (distance_unit === 'miles') {
    isMetric = false
  }
  return (
    <ComparisonPlot
      title={props.title}
      rawData={props.graphReport ? props.graphReport : ([] as any)}
      granularity={props.granularity}
      showAverage={false}
      enableAnimation={props.enableAnimation}
      formatWithUnit={(x) => formatWeight(x, isMetric)}
    />
  )
}
